export const ADD_BACKGROUND_JOB = 'ADD_BACKGROUND_JOB'
export const SET_BACKGROUND_JOBS = 'SET_BACKGROUND_JOBS'
export const UPDATE_JOB = 'UPDATE_JOB'
export const REMOVE_JOB = 'REMOVE_JOB'
export const TERMINATE_JOB = 'TERMINATE_JOB'
